
import Vue from "vue";
import {
  Address,
  AddressType, Contact,
  contactApi, ContactPerson,
  EmailAddress,
  PhoneNumber,
  PhoneNumberType,
} from "@/api/contacts";
import { ValidationProvider } from "vee-validate";
import EventBus from "@/utils/EventBus";
import {SnackbarMsgEvent} from "@/layout/Layout.vue";
// eslint-disable-next-line
const ContactEmail: any = Vue.extend({
  name: "ContactEmail",
  components: {
    ValidationProvider,
  },
  props: {
    email: {
      type: Object as () => EmailAddress,
      required: false,
    },
    contact: {
      type: Object as () => Contact,
      required: false,
    },
    removeable: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentEmailAddress: {} as EmailAddress,
      contactPersons: [] as ContactPerson[],
      init: true,
    };
  },
  watch: {
    contact: {
      handler: async function () {
        if (this.contact) {
          this.contactPersons = [];
          this.contactPersons.push(...this.contact.contactPersons);
          this.contactPersons.push(...this.contact.externalContactPersons);
        }
      },
      immediate: true,
    },
    currentEmailAddress: {
      handler: function () {
        if (!this.init) {
          this.$emit("changed", this.currentEmailAddress);
        }
        this.init = false;
      },
      deep: true,
    },
    email: {
      handler: async function () {
        if (this.email) {
          this.currentEmailAddress = this.email;
          this.init = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    copyToClipboard() {
      if( this.email) {
        navigator.clipboard.writeText(this.email.address).then(function() {
          EventBus.$emit("snackbarInfosTo", { msg: "E-Mail-Adresse erfolgreich kopiert" } as SnackbarMsgEvent);
        }, function(err) {
          EventBus.$emit("snackbarInfosTo", { msg: "E-Mail-Adresse konnte nicht kopiert werden "+err } as SnackbarMsgEvent);
        });
      }
    },
    fireChangeEvent() {
      this.$emit("change", this.currentEmailAddress);
    },
    removeEmailAddress() {
      this.$emit("removeEmailAddress");
    },
  },
});
export default ContactEmail;
